import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { AuthData } from "@/types/LocalConfig";
import Service from "@/services";
import qs from "query-string";
import {
  AppStoreApplication,
  AppStoreGroupApplication,
  WebviewKernel,
  FavoriteType
} from "@/services/AppStore";
import logger from "@/utils/logger";
import IconFont, { IconThirdApp } from "@/components/icon";
import { EventEmitter } from "events";
import ThirdAppContainer from "@/components/ThirdApp/components/ThirdAppContainer";
import BrowserView from "@/components/BrowserView";
import { hasNewStoreApplication } from "@/api/appMarket";
import GError from "@/utils/GError";
import { useTranslation } from "react-i18next";
import { FocusSDK, getWebEnvObj, isBjme, isFocusEnv } from "@/utils";
import Bus from "@/utils/bus";
import { message, Modal } from "antd";
import { connect } from "dvajs";
import { analysisLog } from "@/utils/logAnalytics";
import { getAppVersion, getVersionInfo } from "@/utils/getVersion";
import { GATEWAY_VERSION } from "@/server/constants";
import {
  getLocalFavorite,
  dealThirdApplications,
  dealRecent,
  dealSortByClickNum,
  addFavorite,
  removeFavorite,
  setLocalFavorite,
  removeLocalFavorite,
  getApplication,
  ThirdAppContext,
  PerformanceContext,
  appTrailApply,
  dealRecentGroup,
  FavoviteSortType
} from "./utils";
import InitThirdAppService from "./components/service/InitThirdAppService";
import "./index.less";
import PostMessageService from "@/utils/postMessageClient";
import { AVSDK } from "@/baseComponents/Meeting/common";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { ICardRes, cardHostType, ICard, stillVoid } from "./interface";
import { getAuthorizationCode } from "@/api/user";
import cardTemplateService from "./components/CustomWorkbench/CardTemplateService";
import { appItemMenus } from "@/components/ThirdApp/components/ThirdMenu";
import { v4 } from "uuid";
import getAppEntry from "@/utils/entry";
import { usePrevious } from "@/utils/chat/index";
import { ThirdAppState } from "@/models/thirdapp";
import cloneDeep from "lodash/cloneDeep";

const meetingList = [
  { path: "/xylink", avsdk: AVSDK.XYLINK },
  { path: "/jdmeet", avsdk: AVSDK.JBRTC },
  { path: "/cloudlink", avsdk: AVSDK.HUAWEI },
  { path: "/meeting", avsdk: AVSDK.ZOOM }
];
const log = logger.getLogger("ThirdApp");

export const notifyer = new EventEmitter();

export const genThirdAppUrl = (
  applicationKey: string,
  appId: string,
  accessToken: string,
  appRuntime: AppRuntimeEnv,
  options?: {
    redirectUrl?: string;
  }
  // eslint-disable-next-line max-params
) => {
  const s = new URL(`${appRuntime.meMainEntry}/passport/api/desktop/app/redirect/`);
  s.searchParams.append("applicationKey", applicationKey);
  s.searchParams.append("appKey", appId);
  s.searchParams.append("client", (!isFocusEnv() && "web") || appRuntime.registryConfig.client);
  s.searchParams.append("accessToken", accessToken);
  s.searchParams.append("teamId", appRuntime.selectedTeamId);
  if (options?.redirectUrl) {
    s.searchParams.append("redirectUrl", encodeURIComponent(options.redirectUrl));
  }
  return s.toString();
};

// const getThirdAppUrl = (item: AppStoreApplication, config: AuthData, appRuntime: AppRuntimeEnv) => {
//     return genThirdAppUrl(item.applicationKey, config.ddAppId, config.accessToken, appRuntime);
// };

export const favoriteGroupId = "L5sXtN09X461bVUwc000";
export const RECENT_GRROUP_ID = "L5sXtN09X461bVUwc001";
let recentGroup: {
  groupId: string;
  name: string;
  version: string;
  applications: any[];
} = {
  groupId: RECENT_GRROUP_ID,
  name: "最近使用",
  version: "1648021249394",
  applications: []
};
let topAppIds: any[] = [];

// 获取全部工具
const getThirdAppListAll = async (
  service: Service,
  appRuntimeEnv: AppRuntimeEnv,
  authInfo: AuthData,
  type?: string,
  favoriteSortType?: FavoviteSortType,
  cardLayoutId?: string
  // eslint-disable-next-line max-params
) => {
  console.log("xtlget~service:", service);
  console.log("xtlget~appRuntimeEnv:", appRuntimeEnv);
  console.log("xtlget~authInfo:", authInfo);
  console.log("xtlget~type:", type);
  const localstorageKey = `${authInfo?.userId}_${authInfo?.teamUserInfo.teamId}`;
  let localFavoriteArr = getLocalFavorite(localstorageKey);
  let thirdAppAll: any[] = [];
  let thirdAppListAll: any = [];
  try {
    // // eslint-disable-next-line no-debugger
    // debugger;
    // 其他所有
    const leveldbKey = `${localstorageKey}_thirdAppLications`;
    const GetListService = InitThirdAppService.GetListService();
    let group: any = {};
    try {
      group = (await GetListService.getDBList(`${leveldbKey}`)) || {
        groupApplications: [],
        topApplications: []
      };
    } catch (error) {
      console.log("this is getDBList error", error);
    }
    InitThirdAppService.setGroup(group);
    let groupApplicationVersions: any = {};
    for (let item of group?.groupApplications || []) {
      groupApplicationVersions[item.groupId] = item.version;
    }
    const opt =
      group.version && group.groupApplications
        ? { groupApplicationVersions, version: group.version }
        : {};
    let result: any = await service.appStoreService.getGroupApplications({
      userId: authInfo.userId,
      teamId: appRuntimeEnv.selectedTeamId,
      ...opt
    });
    // GetListService.setDBList(`${leveldbKey}`, result);
    thirdAppAll = result.groupApplications;
    topAppIds = result.topApplications || [];
    // 本地常用应用
    if (!localFavoriteArr) {
      let favoriteArr: any[] = [];
      // 恢复默认
      if (type === "default") {
        const tmpFavorite = await service.appStoreService.getRecommendedApplications({
          userId: authInfo.userId,
          teamId: appRuntimeEnv.selectedTeamId
        });
        favoriteArr = tmpFavorite?.groupApplication?.applications || [];
      } else {
        const tmpFavorite = await service.appStoreService.getFavoriteApplications({
          userId: authInfo.userId,
          teamId: appRuntimeEnv.selectedTeamId
        });
        favoriteArr = tmpFavorite?.applications || [];
      }
      localFavoriteArr = favoriteArr.map((i) => i.applicationId);
    }
    const obj = dealThirdApplications(
      localstorageKey,
      localFavoriteArr,
      thirdAppAll,
      topAppIds,
      RECENT_GRROUP_ID
    );
    const favorite = {
      groupId: favoriteGroupId,
      name: "常用应用",
      version: "1620727481000",
      applications: obj.favorite || []
    };
    // const recent = {
    //     groupId: RECENT_GRROUP_ID,
    //     name: '最近使用',
    //     version: '1648021249394',
    //     applications: obj.recent,
    // };
    recentGroup.applications = obj.recent;
    const defaultAppList = [favorite];
    obj.recent && obj.recent.length > 0 && defaultAppList.push(recentGroup);
    thirdAppListAll = defaultAppList.concat(obj.thirdApplications);
    dealRecentGroup(localstorageKey, thirdAppListAll, RECENT_GRROUP_ID);
    // console.log("this is thirdapplistapp", thirdAppListAll);
    type === "default" && cardLayoutId && Bus.emit(`card:refresh:${cardLayoutId}`);
  } catch (error) {
    FocusSDK.printLog("init third application group error", error);
    console.error(error);
  }

  return thirdAppListAll;
};
const getAppStoreUrl = (appRuntimeEnv: AppRuntimeEnv, authInfo: AuthData) => {
  try {
    const urlObj = new URL(`${appRuntimeEnv.meMainEntry}/app_store`);
    urlObj.searchParams.append("appKey", appRuntimeEnv.gateway.appId);
    urlObj.searchParams.append("appVersion", getAppVersion(FocusSDK));
    urlObj.searchParams.append(
      "client",
      (!isFocusEnv() && "web") || appRuntimeEnv.registryConfig.client
    );
    urlObj.searchParams.append("did", appRuntimeEnv.registryConfig.machineId);
    urlObj.searchParams.append("gwVersion", GATEWAY_VERSION as any);
    urlObj.searchParams.append("stage", appRuntimeEnv.gateway.stage);
    urlObj.searchParams.append("teamId", appRuntimeEnv.selectedTeamId);
    urlObj.searchParams.append("accessToken", authInfo.accessToken);
    urlObj.searchParams.append("hostAppId", (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork");
    urlObj.searchParams.append("isPrivateNet", FocusSDK.isPrivateNet().toString());
    let secretKey = "";
    if (FocusSDK.getDeviceInfo().platform === "web") {
      secretKey = getWebEnvObj().REACT_APP_WEB_SECRETKEY || "";
    } else {
      secretKey = getWebEnvObj().REACT_APP_DESKTOP_SECRETKEY || "";
    }
    urlObj.searchParams.append("secretKey", secretKey);
    return urlObj.toString();
  } catch (err) {
    console.log(err);
  }
};

function StartupBody({
  visible,
  loading,
  selectedId,
  thirdAppListAll,
  cards,
  onCardsOrderChange,
  onAddCard,
  onDeleteCard,
  appRuntimeEnv,
  authInfo,
  hasNewStoreApp,
  isActive,
  openAppStore,
  isOnline,
  getAppListAll,
  isApplications,
  favoriteSortType,
  onChangeFavoriteSortType,
  localstorageKey
}: {
  visible?: boolean;
  loading: boolean;
  selectedId: string;
  thirdAppListAll: any;
  cards: ICardRes;
  onCardsOrderChange: (newCards: any) => void;
  onAddCard: (card: ICard) => void;
  onDeleteCard?: (card: ICard) => void;
  appRuntimeEnv: AppRuntimeEnv;
  authInfo: AuthData;
  hasNewStoreApp: boolean;
  isActive: boolean;
  openAppStore: () => void;
  isOnline: boolean;
  getAppListAll: Function;
  isApplications?: boolean;
  favoriteSortType: FavoviteSortType;
  onChangeFavoriteSortType: (type: FavoviteSortType) => void;
  localstorageKey: string;
}) {
  const isPrivateNet = FocusSDK.isPrivateNet();
  return (
    <ThirdAppContext.Provider
      value={{
        topAppIds,
        isOnline,
        isActive,
        notifyer,
        favoriteSortType,
        onChangeFavoriteSortType
      }}
    >
      <div
        style={{
          display: selectedId === "startup-page" ? "block" : "none",
          height: "100%"
        }}
      >
        <ThirdAppContainer
          groups={thirdAppListAll}
          cards={cards}
          openAppStore={openAppStore}
          onCardsOrderChange={onCardsOrderChange}
          onAddCard={onAddCard}
          onDeleteCard={onDeleteCard}
          isPrivateNet={isPrivateNet}
          hasNewStoreApp={hasNewStoreApp}
          getAppListAll={getAppListAll}
          isApplications={isApplications}
          localstorageKey={localstorageKey}
        />
      </div>
    </ThirdAppContext.Provider>
  );
}

function ThirdApp(props: any) {
  const { authInfo: config, appRuntimeEnv, service, onGlobalError, focusSDK } = React.useContext<
    GlobalContextConfig
  >(GlobalContext);
  const [selectedId, setSelectedId] = React.useState("startup-page");
  const [openLinkList, setOpenLinkList] = React.useState([]);
  const [thirdAppListAll, setThirdAppListAll] = useState<AppStoreGroupApplication[]>([]);
  // 从ai助手卡片进入工作台时，thirdAppListAll的数据还为空，需要同步获取全部应用
  const theThirdAppListAll = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("common");
  const { setThirdAppData, isApplications, connectState } = props;
  const localstorageKey = `${config?.userId}_${config?.teamUserInfo.teamId}`;
  const [hasNewStoreApp, setHasNewStoreApp] = useState(false);
  const [cards, setCards] = useState<ICardRes>({ addedCards: [], remainingCards: [] });
  const [isActive, setIsActive] = useState(true);
  const [isOnline, setIsOnline] = useState(false);
  const [appClickTime, setAppClickTime] = useState(0);
  const [favoriteSortType, setFavoriteSortType] = useState(FavoviteSortType.BySort);

  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl(),
    checkType: UseCheckType.API
  });
  const preState = usePrevious(connectState?.state);

  const location = useLocation();

  useEffect(() => {
    netServer.checkNet().then((res) => {
      setIsOnline(res);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (connectState?.state !== preState && connectState?.state === ConnectState.READY) {
      netServer.checkNet().then((res) => {
        setIsOnline(res);
      });
    }
  }, [preState, connectState?.state]);

  const getVersion = () => {
    try {
      const appversionInfo = getVersionInfo(FocusSDK);
      const registryConfig = appRuntimeEnv.registryConfig;
      const appVersion = (appversionInfo && appversionInfo.appVersion) || registryConfig.pkgVersion;
      const buildVersion =
        (appversionInfo && appversionInfo.buildVersion) || registryConfig.pkgBuildVersion;

      return `${appVersion.split("-")[0]}.${
        isNaN(buildVersion) ? 0 : Number(buildVersion || 0) % 1000
      }`;
    } catch (e) {
      console.log(e);
      return "";
    }
  };

  const getCards = useCallback(() => {
    service.appStoreService
      .getCards({
        hostType: cardHostType.pc,
        appVersion: getVersion()
      })
      .then((res: any) => {
        setCards(res as ICardRes);
      })
      .catch((e) => {});
  }, [service.appStoreService]);

  const handleCards = useCallback(
    async (cardIds: string[]) => {
      await service.appStoreService.updateCards({
        cardIds,
        hostType: cardHostType.pc
      });
      getCards();
    },
    [getCards, service.appStoreService]
  );

  const onCardsOrderChange = useCallback(
    async (newCards: any) => {
      handleCards(newCards.map((card: any) => card.cardId));
    },
    [handleCards]
  );
  const onAddCard = useCallback(
    async (card: ICard) => {
      const newCards = [...cards.addedCards, card];
      handleCards(newCards.map((card: any) => card.cardId));
    },
    [cards.addedCards, handleCards]
  );
  const onDeleteCard = useCallback(
    (card: ICard) => {
      const newCards = [...cards.addedCards].filter((item: any) => item.cardId !== card.cardId);
      handleCards(newCards.map((card: any) => card.cardId));
    },
    [cards.addedCards, handleCards]
  );
  const openAppStore = useCallback(() => {
    try {
      FocusSDK.printLog("open app store");
      setHasNewStoreApp(false);
      analysisLog("xtbg_appstore_1", "5");
      const appStoreUrl = getAppStoreUrl(appRuntimeEnv, config);
      if (FocusSDK.getDeviceInfo().platform === "web") {
        appStoreUrl && FocusSDK.openUrl(appStoreUrl);
      } else {
        notifyer.emit("clientMessage", {
          event: "openNewWindow",
          payload: {
            urls: [appStoreUrl]
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  }, [appRuntimeEnv, config]);
  const history = useHistory();

  const checkNeedAuth = async (applicationKey: string) => {
    const result = await service.appStoreService.checkApplicationNeedAuth({
      appKey: applicationKey,
      userId: config?.userId,
      teamId: appRuntimeEnv.selectedTeamId,
      mode: "sdk"
    });
    console.log(" service.appStoreService", result);
    return result;
  };

  const submitAuth = async (applicationKey: string, authorize: boolean) => {
    const result = await service.appStoreService.submitApplicationAuth({
      appKey: applicationKey,
      userId: config?.userId,
      teamId: appRuntimeEnv.selectedTeamId,
      mode: "sdk",
      authorize: authorize
    });
    return result;
  };

  const doAuthConfirm = (name: string, icon: string) => {
    return new Promise((resolve) => {
      Modal.confirm({
        title: `${name}申请`,
        icon: <img src={icon} />,
        className: "auth-confirm",
        content: "获取您的姓名、单位、部门等信息用于登录。",
        okText: "允许",
        cancelText: "拒绝",
        onOk: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        }
      });
    });
  };

  // 打开工具
  const openThirdApp = React.useCallback(
    // eslint-disable-next-line complexity
    async (curitem, info, force = false) => {
      console.log("打开应用", curitem, info);
      setAppClickTime(new Date().getTime());
      let item = getApplication(
        theThirdAppListAll.current,
        (item) => item.applicationKey === curitem.applicationKey
      );
      // FocusSDK.printLog("openThirdApp", curitem);
      // 添加最近使用
      // dealRecent(localstorageKey, item, thirdAppListAll, recentGroup, info);
      dealSortByClickNum(localstorageKey, item, info);
      if (favoriteSortType === FavoviteSortType.BySort) {
        dealRecentGroup(localstorageKey, thirdAppListAll, RECENT_GRROUP_ID);
      }
      // 必须在处理最近使用下面，因为，最近使用需要根据item是否为null判定是否加入最近使用
      if (force) {
        item = curitem || item;
      } else {
        item = item || curitem;
      }
      console.log("tj:>>>>>打开应用>>111", item);
      try {
        // if (FocusSDK.isPrivateNet()) {
        //     let appName = item.name || '';
        //     let homeUrl = item.homeUrl || '';
        //     if (appName !== '信创会议' && homeUrl.indexOf('/cloudlink') === -1) {
        //         message.warn(t('joinMeeting.private net'));
        //         return;
        //     }
        // }
        let redirectUrl: string | null = "";
        try {
          redirectUrl = new URL(item.homeUrl).searchParams.get("redirectUrl");
        } catch (e) {
          console.log("this is redirect", e);
        }
        const src = genThirdAppUrl(
          item.applicationKey,
          config.ddAppId,
          config.accessToken,
          appRuntimeEnv,
          {
            redirectUrl: redirectUrl || (force ? item.homeUrl : "")
          }
        );
        console.log("thirdappurl", src);
        // 防止一个应用重复打开，注意浏览器打开的不走该逻辑
        // const openApp: any = openLinkList.find((item: any) => item.link === src);
        // if (openApp) {
        //     setSelectedId(openApp.id);
        //     notifyer.emit('onOpenApp', openApp.id);
        //     return;
        // }
        const result = await checkNeedAuth(item.applicationKey);
        if (result?.supportMode && result?.needAuth) {
          const isConfirm = await doAuthConfirm(result?.appName || "", result?.appIcon || "");
          const submitResult = await submitAuth(item.applicationKey, !!isConfirm);
          if (isConfirm && submitResult?.authorize) {
            message.success("授权成功");
          } else if (!isConfirm) {
            message.error("已拒绝授权");
          } else {
            message.error("授权失败");
          }
        }
        log.debug("open third app, appKey: %s, webviewKernel: %s", item, item.webviewKernel);

        analysisLog(
          "xtbg_workbench_1",
          "1",
          item.applicationId,
          item.name,
          item?.applicationKey || ""
        );
        switch (item.webviewKernel) {
          case WebviewKernel.MainWindow: {
            setThirdAppData({ appId: item.applicationId, appData: item });
            log.debug("主窗口打开 ===>>>", src, item);
            notifyer.emit("clientMessage", {
              event: "openNewWindow",
              payload: {
                urls: [src],
                name: item.name,
                originIcon: item.icon,
                description: item.description,
                phone: item.csTelephone || "",
                company: item.omCompany || "",
                appKey: item.applicationKey,
                trustedDomains: item.trustedDomains || "",
                version: item.version,
                shareStatus: item.shareStatus,
                isThirdApp: true,
                homeUrl: FocusSDK.isPrivateNet() ? item.egovHomeUrl || item.homeUrl : item.homeUrl
              }
            });
            break;
          }
          case WebviewKernel.NewWindow: {
            if (meetingList.find((i) => i.path === item.homeUrl.split("?")[0])) {
              const MeetingHost = getAppEntry();
              const type = item.homeUrl.split("?")[0];
              const avsdk = meetingList.find((i) => i.path === type)?.avsdk || AVSDK.ZOOM;
              const search = curitem.homeUrl.split("?")[1];
              const qsparams = qs.parse(search);
              if (isFocusEnv()) {
                // 适配会议应用独立窗口
                item.applicationId && setThirdAppData({ appId: item.applicationId, appData: item });
                log.debug("内置浏览器打开 ===>>>", src, "催办，任务，云空间，视屏会议");
                const params = {
                  timestamp: new Date().getTime(),
                  icon: item.icon,
                  avsdk,
                  title: item.name,
                  ...qsparams
                };
                notifyer.emit("clientMessage", {
                  event: "openNewWindow",
                  payload: {
                    urls: [`${MeetingHost}/meeting-home.html?${qs.stringify(params)}`],
                    name: item.name,
                    phone: item.csTelephone || "",
                    company: item.omCompany || "",
                    appKey: item.applicationKey,
                    trustedDomains: item.trustedDomains || "",
                    version: item.version,
                    isThirdApp: false // 内部应用
                  }
                });
              } else {
                const pmService = PostMessageService.getInstance(avsdk) as PostMessageService;
                const params = {
                  title: item.name,
                  avsdk,
                  timestamp: new Date().getTime()
                };
                pmService
                  .openServer(`${MeetingHost}/meeting-home.html?${qs.stringify(params)}`, {
                    clientInfo: { name: `meeting-${avsdk}` }
                  })
                  .then(() => {
                    pmService.postMessage("metadata", {
                      title: item.name,
                      icon: item.icon
                    });
                  });
              }
            } else {
              // log.debug('内置浏览器打开 ===>>>', src, '催办，任务，云空间，视屏会议');
              history.push({
                pathname: FocusSDK.isPrivateNet() ? item.egovHomeUrl || item.homeUrl : item.homeUrl
              });
            }

            break;
          }
          case WebviewKernel.WebBrowser: {
            log.debug("外部浏览器打开 ===>>>", src);
            focusSDK.openUrl(src);
            break;
          }
          default:
            throw GError.fromError(new Error(t("error.thirdAppConfigError")));
        }
      } catch (error) {
        console.log("错误", error);
        onGlobalError(error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appRuntimeEnv, config, focusSDK, onGlobalError, t, history, thirdAppListAll]
  );
  // 修改所有数据
  const onChangeListAll = useCallback(
    (listAll: AppStoreGroupApplication[], applicationId: string, favorite: FavoriteType) => {
      for (const group of listAll) {
        for (const appInfo of group.applications) {
          if (appInfo.applicationId === applicationId) {
            appInfo.favorite = favorite;
          }
        }
      }
      setThirdAppListAll(listAll);
    },
    []
  );
  // 添加常用工具
  const onAddFavoriteThirdApp = useCallback(
    async (appInfo: AppStoreApplication) => {
      if (!isOnline) {
        return;
      }
      FocusSDK.printLog("add favorite third application", JSON.stringify(appInfo));
      // 触发loading
      Bus.emit("setLoading", {
        loading: true,
        applicationId: appInfo.applicationId
      });
      analysisLog(
        "xtbg_workbench_1",
        "3",
        appInfo.applicationId,
        appInfo.name,
        appInfo?.applicationKey || ""
      );
      try {
        const result = await service.appStoreService.addFavoriteApplication({
          applicationId: appInfo.applicationId,
          userId: config?.userId,
          teamId: appRuntimeEnv.selectedTeamId
        });
        const list = [...thirdAppListAll];
        const groupItem: any | null =
          list.find((item: AppStoreGroupApplication) => item.groupId === favoriteGroupId) || null;
        if (groupItem) {
          appInfo.favorite = FavoriteType.FavoriteYes;
          groupItem.applications.push(appInfo);
          onChangeListAll(list, appInfo.applicationId, FavoriteType.FavoriteYes);
          // 触发筛选
          Bus.emit("onSearchUpData", appInfo);
          // 添加应用
          Bus.emit("onAddAppData", appInfo);
          // 关闭loading
          Bus.emit("setLoading", {
            loading: false,
            applicationId: appInfo.applicationId
          });
          addFavorite(localstorageKey, appInfo.applicationId);
        }
        message.success("添加成功");
        appInfo.emitCallback?.();
      } catch (error) {
        FocusSDK.printLog("add favorite application error", error);
        message.error("添加失败,请重试");
        Bus.emit("setLoading", { loading: false, applicationId: appInfo.applicationId });
      }
    },
    [
      thirdAppListAll,
      onChangeListAll,
      localstorageKey,
      config?.userId,
      appRuntimeEnv.selectedTeamId,
      service.appStoreService,
      isOnline
    ]
  );
  // 移除常用工具
  const removeFavoriteThirdApp = useCallback(
    async (appInfo: AppStoreApplication) => {
      if (!isOnline) {
        return false;
      }
      FocusSDK.printLog("remove favorite third application", JSON.stringify(appInfo));
      Bus.emit("setLoading", { loading: true, applicationId: appInfo.applicationId });
      analysisLog(
        "xtbg_workbench_1",
        "4",
        appInfo.applicationId,
        appInfo.name,
        appInfo?.applicationKey || ""
      );
      try {
        const result = await service.appStoreService.removeFavoriteApplication({
          applicationId: appInfo.applicationId,
          userId: config?.userId,
          teamId: appRuntimeEnv.selectedTeamId
        });
        const list = [...thirdAppListAll];
        const groupItem: any | null =
          list.find((item: AppStoreGroupApplication) => item.groupId === favoriteGroupId) || [];
        const idx = groupItem.applications.findIndex(
          (item: AppStoreApplication) => item.applicationId === appInfo.applicationId
        );
        if (groupItem && idx !== -1) {
          appInfo.favorite = FavoriteType.FavoriteNo;
          groupItem.applications.splice(idx, 1);
          onChangeListAll(list, appInfo.applicationId, FavoriteType.FavoriteNo);
          Bus.emit("setLoading", {
            loading: false,
            applicationId: appInfo.applicationId
          });
          // 触发筛选
          Bus.emit("onSearchUpData", appInfo);
          // 移除应用
          Bus.emit("onRemoveAppData", appInfo);
        }
        removeFavorite(localstorageKey, appInfo.applicationId);
        message.success("取消成功");
        appInfo.emitCallback?.();
      } catch (error) {
        FocusSDK.printLog("remove favorite third application error", error);
        message.error("添加失败,请重试");
        Bus.emit("setLoading", { loading: false, applicationId: appInfo.applicationId });
      }
    },
    [
      thirdAppListAll,
      onChangeListAll,
      localstorageKey,
      appRuntimeEnv.selectedTeamId,
      config?.userId,
      service.appStoreService,
      isOnline
    ]
  );
  // 获取全部分类及分类下的工具列表
  const getAppListAll = useCallback(
    async (type?: string, favoriteSortType?: FavoviteSortType, cardLayoutId?: string) => {
      setLoading(true);
      FocusSDK.printLog("enter third application", type);
      const list = await getThirdAppListAll(
        service,
        appRuntimeEnv,
        config,
        type,
        favoriteSortType || FavoviteSortType.BySort,
        cardLayoutId
      );
      // FocusSDK.printLog('get third application list', list);
      setLoading(false);
      theThirdAppListAll.current = list;
      setThirdAppListAll(list);
      Bus.emit("thirdapp:ready");
      return list;
    },
    [service, appRuntimeEnv, config]
  );
  const onChangeFavoriteSortType = useCallback((type) => {
    Bus.emit("card:refresh:favoriteSortType", type);
    getAppListAll("", type);
    setFavoriteSortType(type);
  }, []);

  // 布局
  const defaultPage = {
    id: "startup-page",
    icon: IconThirdApp,
    title: isBjme() ? t("thirdapp.tools-center") : t("thirdapp.application-center"),
    body: (
      <StartupBody
        visible
        loading={loading}
        thirdAppListAll={thirdAppListAll}
        cards={cards}
        onCardsOrderChange={onCardsOrderChange}
        onAddCard={onAddCard}
        onDeleteCard={onDeleteCard}
        selectedId={selectedId}
        appRuntimeEnv={appRuntimeEnv}
        authInfo={config}
        hasNewStoreApp={hasNewStoreApp}
        isActive={isActive}
        openAppStore={openAppStore}
        isOnline={isOnline}
        getAppListAll={getAppListAll}
        isApplications={isApplications}
        favoriteSortType={favoriteSortType}
        onChangeFavoriteSortType={onChangeFavoriteSortType}
        localstorageKey={localstorageKey}
      />
    )
  };
  // 批量编辑常用工具
  const onEditFavoriteApplication = useCallback(
    async (applicationIds, list: any, cardLayoutId?: string) => {
      try {
        const res = await service.appStoreService.editFavoriteApplication({
          userId: config?.userId,
          teamId: appRuntimeEnv.selectedTeamId,
          applicationIds: list.map((i: any) => i.applicationId)
        });
        // 修改排序
        const groupList = [...thirdAppListAll];
        const appInfo = groupList.find((item) => item.groupId === favoriteGroupId);
        if (!appInfo) {
          return;
        }
        appInfo.applications = list;
        setLocalFavorite(
          localstorageKey,
          list.map((i: any) => i.applicationId)
        );
        setThirdAppListAll(groupList);
        cardLayoutId && Bus.emit(`card:refresh:${cardLayoutId}`);
        message.success("保存成功");
      } catch (error) {
        FocusSDK.printLog("edit favorite application error", error);
        message.error("保存失败,请重试");
      }
    },
    [
      thirdAppListAll,
      localstorageKey,
      config?.userId,
      appRuntimeEnv.selectedTeamId,
      service.appStoreService
    ]
  );

  const onResetFavorite = useCallback(
    (data: any) => {
      const { type, cardLayoutId } = data;
      removeLocalFavorite(localstorageKey);
      getAppListAll(type, undefined, cardLayoutId);
    },
    [getAppListAll, localstorageKey]
  );

  const openThirdAppByNoticeCard = useCallback(
    async (item, info) => {
      // eslint-disable-next-line
      // debugger;
      FocusSDK.printLog("open third application by noticeCard", item, info);
      await getAppListAll();
      openThirdApp(item, info, true);
    },
    [getAppListAll, openThirdApp]
  );

  const openThirdAppByWorkPlateCard = useCallback(
    async ({
      openUrl,
      appKey,
      openApiType,
      code,
      isNewThirdappAnalysis
    }: {
      appKey: string;
      openApiType: number;
      openUrl: string;
      code?: string;
      isNewThirdappAnalysis?: boolean;
    }) => {
      if (isNewThirdappAnalysis) {
        notifyer.emit("clientMessage", {
          event: "openNewWindow",
          payload: {
            urls: [null],
            appKey: appKey,
            isNewThirdappAnalysis,
            name: "新增应用统计",
            icon: <IconFont type="iconic_pc_statistics" />
          }
        });
        return;
      }
      let src = openUrl;
      if (code) {
        const [success, err] = await getAuthorizationCode({ appKey });
        if (success) {
          try {
            const srcIns = new URL(src);
            srcIns.searchParams.set("code", success.code);
            src = srcIns.toString();
          } catch (error) {

          }
        }
      } else {
        if (openApiType === 2) {
          // src = genThirdAppUrl(cardInfo.cardId, config.ddAppId, config.accessToken, appRuntimeEnv, {
          //   redirectUrl: src
          // });
          src = genThirdAppUrl(appKey, config.ddAppId, config.accessToken, appRuntimeEnv, {
            redirectUrl: src
          });
        } else if (openApiType === 1) {
          try {
            const srcIns = new URL(src);
            const teamId =
              appRuntimeEnv.selectedTeamId || config.selectedTeamId || config.teamUserInfo.teamId;
            srcIns.searchParams.set("teamid", teamId);
            srcIns.searchParams.set("userid", config.userId);
            srcIns.searchParams.set("accesstoken", config.accessToken);
            srcIns.searchParams.set("hostAppId", (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork");
            src = srcIns.toString();
          } catch (error) {

          }
        }
      }
      if (isFocusEnv()) {
        notifyer.emit("clientMessage", {
          event: "openNewWindow",
          payload: {
            urls: [src],
            appKey: appKey,
            isNewThirdappAnalysis
          }
        });
      } else {
        FocusSDK.openUrl(src);
      }
    },
    [
      appRuntimeEnv,
      config?.accessToken,
      config?.ddAppId,
      config?.selectedTeamId,
      config?.teamUserInfo.teamId,
      config?.userId
    ]
  );

  const onOpenFormSubmitWindow = useCallback((data) => {
    notifyer.emit("clientMessage", {
      event: "openNewWindow",
      payload: {
        urls: [`file://${FocusSDK.getAppLoadingPath()}`],
        data,
        isFormSubmit: true
      }
    });
  }, []);

  const openStoreApplication = useCallback(() => {
    hasNewStoreApplication()
      .then((res: any) => {
        setHasNewStoreApp(res?.hasNewStoreApplication);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // useEffect(() => {
  //   const pathname = location.pathname;
  //   if (pathname.indexOf("third_apps") > -1) {
  //     setIsActive(true);
  //   } else {
  //     setIsActive(false);
  //   }
  // }, [location]);

  const onNavItemClick = useCallback(
    (path: string) => {
      if (path === "/third_apps") {
        getAppListAll();
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    },
    [getAppListAll]
  );

  cardTemplateService.addService<any, stillVoid>("thirdapp", {
    appItemMenus
  });
  cardTemplateService.addService<any, stillVoid>("thirdapp", {
    openThirdApp: (appInfo) => {
      appTrailApply(
        appInfo.applicationId,
        () => {
          openThirdApp(appInfo, appInfo);
        },
        notifyer,
        appInfo
      );
    }
  });
  cardTemplateService.addService<any, Promise<any>>("thirdapp", {
    getApplicationList: (params) => {
      return new Promise((resolve, reject) => {
        getAppListAll().then((res) => {
          console.log("获取应用的列表", res);
          resolve(res);
        });
      });
    }
  });
  cardTemplateService.addService<any, stillVoid>("thirdapp", {
    gotoApplications: (params) =>
      notifyer.emit("clientMessage", {
        event: "openNewWindow",
        payload: {
          urls: [window.location.href],
          isApplications: true,
          icon: <IconFont type="iconapp_tabbar_application" />,
          name: "全部应用",
          appKey: "all-thirapp"
        }
      }),
    isFavoriteThirdApp: (appInfo: any, callback?: any) => {
      const { favorite = FavoriteType.FavoriteNo } = appInfo;
      if (callback) {
        appInfo = { ...appInfo, emitCallback: callback };
      }
      favorite === FavoriteType.FavoriteNo
        ? Bus.emit("onAddFavoriteThirdApp", appInfo)
        : Bus.emit("removeFavoriteThirdApp", appInfo);
    }
  });

  const openInsideRouteByWorkPlateCard = useCallback(() => {
    setIsActive(false);
  }, []);
  // 获取全部数据及添加监听
  const initRef = useRef("");
  useEffect(() => {
    if (!config) {
      return;
    }
    if (!initRef.current) {
      initRef.current = "init";
      getAppListAll();
    }
    getCards();
    openStoreApplication();
    Bus.on("openThirdApp", openThirdApp);
    Bus.on("onAddFavoriteThirdApp", onAddFavoriteThirdApp);
    Bus.on("removeFavoriteThirdApp", removeFavoriteThirdApp);
    Bus.on("onEditFavoriteApplication", onEditFavoriteApplication);
    Bus.on("onResetFavorite", onResetFavorite);
    Bus.on("onNavItemClick", onNavItemClick);
    Bus.on("openThirdAppByNoticeCard", openThirdAppByNoticeCard);
    Bus.on("openThirdAppByWorkPlateCard", openThirdAppByWorkPlateCard);
    Bus.on("openInsideRouteByWorkPlateCard", openInsideRouteByWorkPlateCard);
    FocusSDK.on("openFormSubmitWindow", onOpenFormSubmitWindow);
    return () => {
      Bus.off("openThirdApp", openThirdApp);
      Bus.off("onAddFavoriteThirdApp", onAddFavoriteThirdApp);
      Bus.off("removeFavoriteThirdApp", removeFavoriteThirdApp);
      Bus.off("onEditFavoriteApplication", onEditFavoriteApplication);
      Bus.off("onResetFavorite", onResetFavorite);
      Bus.off("onNavItemClick", onNavItemClick);
      Bus.off("openThirdAppByNoticeCard", openThirdAppByNoticeCard);
      Bus.off("openThirdAppByWorkPlateCard", openThirdAppByWorkPlateCard);
      Bus.off("openInsideRouteByWorkPlateCard", openInsideRouteByWorkPlateCard);
      FocusSDK.off("openFormSubmitWindow", onOpenFormSubmitWindow);
    };
  }, [
    getAppListAll,
    onNavItemClick,
    openThirdApp,
    onAddFavoriteThirdApp,
    removeFavoriteThirdApp,
    onEditFavoriteApplication,
    onResetFavorite,
    openThirdAppByNoticeCard,
    openStoreApplication,
    getCards,
    openThirdAppByWorkPlateCard,
    onOpenFormSubmitWindow
  ]);
  const handleNetworkChange = useCallback(
    (data: any) => {
      const { connectState } = data;
      if (!thirdAppListAll.length && connectState.state === ConnectState.READY) {
        getAppListAll();
      }
    },
    [thirdAppListAll, getAppListAll]
  );
  useEffect(() => {
    Bus.on("chat:connect_state_change", handleNetworkChange);
    return () => {
      Bus.off("chat:connect_state_change", handleNetworkChange);
    };
  }, [handleNetworkChange]);
  // 从搜索跳转到第三方工具
  // const location = useLocation();
  // useEffect(() => {
  //     const applicationInfo = ((location.state || {}) as any).applicationInfo;
  //     console.log(applicationInfo, '<===applicationInfoapplicationInfowww2222');
  //     console.log(location, 'locationlocationlocation');
  //     if (location.state && applicationInfo) {
  //         location.state = {};
  //         console.log(applicationInfo, '<===applicationInfo');
  //         openThirdApp(applicationInfo);
  //     }
  // }, [location, openThirdApp]);
  // 选择父元素并设置父元素高度100%， 应为该组件用了 CacheRoute 导致高度塌陷。
  useEffect(() => {
    const fatherDiv: any = (document.getElementById("third-apps") as any).parentNode;
    fatherDiv.style.height = "100%";
  }, []);

  const getOpenLinks = (links: any) => {
    setOpenLinkList(links);
  };
  useEffect(() => {
    notifyer.on("getOpenLinks", getOpenLinks);
  });

  return (
    <PerformanceContext.Provider value={{ appClickTime }}>
      <ThirdAppContext.Provider
        value={{
          topAppIds,
          isOnline,
          isActive,
          notifyer,
          favoriteSortType,
          onChangeFavoriteSortType
        }}
      >
        <div
          id="third-apps"
          style={{
            flexDirection: "column",
            height: "100%"
          }}
        >
          <BrowserView
            configData={{
              urls: [],
              partition: "builtin-third-apps",
              allowedHosts: []
            }}
            notifier={notifyer}
            defaultPage={defaultPage}
            onTabChange={(selectedId1: any) => {
              setSelectedId(selectedId1);
            }}
            openThirdApp={openThirdApp}
            style={{ display: "block", height: "calc(100% - 48px)" }}
            isApplications={isApplications}
            thirdAppListAll={thirdAppListAll}
          />
        </div>
      </ThirdAppContext.Provider>
    </PerformanceContext.Provider>
  );
}
function mapStateToProps({ chat, thirdapp }: any) {
  return {
    connectState: chat.connectState,
    thirdAppMsgCount: thirdapp.thirdAppMsgCount
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    setThirdAppData(data: any) {
      dispatch({ type: "thirdapp/setThirdAppData", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThirdApp);
